<script>
import lazyLoadComponent from '@router/lazyload-component'
import { genderFilter, orderStatusFilter, bookingStatusFilter, orderPaymentMethodFilter, orderSourceFilter, paymentStatusMapFilter } from '@utils/filter-value-to-text'
import formatDate from '@utils/format-date'
import pageMixin from '@src/mixins/pagination'


export default {
  page: {
    title: '訂單查詢',
    meta: [{ name: 'description', content: 'Order List' }],
  },
  components: {
    BaseStateLabel: () => lazyLoadComponent(import('@components/BaseStateLabel')),
    ScheduleStaffForm: () => lazyLoadComponent(import('@components/ScheduleStaff/ScheduleStaffForm')),
    ReservationOrderDetail: () => lazyLoadComponent(import('@components/Orders/ReservationOrderDetail')),
    EmployeeReservationOrderDetail: () => lazyLoadComponent(import('@components/Orders/EmployeeReservationOrderDetail')),
  },
  filters: {
    genderFilter,
    orderStatusFilter,
    bookingStatusFilter,
    orderPaymentMethodFilter,
    orderSourceFilter,
    formatDate,
    paymentStatusMapFilter
  },
  mixins: [pageMixin],
  props: {
    defaultValue: {
      type: Object,
      default: () => { },
    },
    type: {
      type: String,
      default: '',
    },
    isSpace: {
      type: Boolean,
      default: false
    },
    fetchTypes: {
      type: Array, 
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      componentKey: 0,
      drawerVisible: false,
      drawerOrderData: '',
      loadedOrders: [],
      tryingToGetOrder: false,
      filterMonth: new Date(),
      avatarWidth: 90,

      dialogVisible: false,
      dialogItem: {},
      visibleEdit: false,
      appStyle: process.env.VUE_APP_BUILD_MODE === 'admin-app-build',
      openBasicInfo: false,
      fullWidth: window.innerWidth
    }
  },
  computed: {
    fetchDataParams() {
      const routeQuery = this.$route.query
      const queryData = Object.assign(routeQuery, this.pageQuery)
      return {
        id: this.defaultValue.id,
        date: this.filterMonth,
        ...queryData,
      }
    },
    storeTitles() {
      return this.defaultValue.storeTitles.join('、')
    },
    userGroupTitles() {
      const titles = this.defaultValue.userGroups.map((item) => item.title)
      return titles.join('、')
    },
  },
  watch: {
    defaultValue: {
      handler: 'handleDefaultValueUpdate',
      immediate: true,
    },
    currentPage: {
      handler: 'tryToFetchList',
    },
    fullWidth(nvl, ovl) {
      if (nvl >= 768) {
        this.openBasicInfo = true
      }
      if (ovl > 768 && nvl <= 768) {
        this.openBasicInfo = false
      }
      if (ovl < 768 && nvl >= 768) {
        this.openBasicInfo = true
      }
    }
  },
  mounted() {
    window.onresize = () => {
      this.fullWidth = window.innerWidth;
    };
    this.openBasicInfo = this.type === 'emplyee' ? false : true
  },
  methods: {
    openBasic() {
      this.openBasicInfo = !this.openBasicInfo
    },
    tableRowClassName({ row }) {
      const rowStatus = row.status
      const usedStatus = row.groupSize / row.usedSize
      if (rowStatus === 0) return 'order--canceled'
      if (usedStatus === 1) return 'order--used'
    },
    async tryToGetOrder(orderId) {
      this.tryingToGetOrder = true
      this.drawerOrderData = await this.$store.dispatch('order/fetchSingle', orderId)
      this.tryingToGetOrder = false
      this.drawerVisible = true
    },
    async tryToFetchList() {
      const detail = await this.$store.dispatch('schedule/fetchStaffDetail', this.fetchDataParams)
      this.$emit('update:defaultValue', detail)
    },
    goBack() {
      this.$emit('back')
    },
    handleDefaultValueUpdate() {
      this.$nextTick(() => {
        const {
          orders: {
            items,
            pagination: { total },
          },
        } = this.defaultValue
        this.loadedOrders = items
        this.$refs.pagination && this.$refs.pagination.updateTotal(total)
      })
    },
    closeEdit() {
      this.visibleEdit = false
    },
    /**
     * @description 編輯資訊
     */
    onClickEdit() {
      const { ordersCount, ordersTotal, orders, ...dialogItem } = this.defaultValue
      this.dialogItem = dialogItem
      this.visibleEdit = true
      if (this.type !== 'employee') {
        this.$emit('showOffOuterTab')
      }
    },
    onCellClick(row) {
      this.tryToGetOrder(row.id)
    },
  },
}
</script>

<template>
  <div :class="{ [$style.isStyleEmployee]: type === 'employee' }"
    :style="type === 'employee' ? 'margin-top: 7px' : 'margin-top: 30px'">
    <template v-if="!visibleEdit">
      <div v-if="type !== 'employee'" :class="[$style['header'], $style['flex']]" style="padding-top:0">
        <div>
          <el-page-header :content="`${isSpace ? '空間': '人員'}詳情`" @back="goBack"></el-page-header>
        </div>
      </div>
      <el-card :class="[$style['info'], { isEmployeeMob: type === 'employee' }]" :shadow="'never'">
        <!-- 1. 左大區塊 -->
        <div :class="[$style.leftRegion, { isEmployeeMob: type === 'employee' }]">
          <!-- 2. 大頭貼 + 大頭貼右邊資訊 -->
          <div :class="$style['leftRegion__top']">
            <div :class="$style['leftRegion__top_img']">
              <el-avatar class="avatar" :src="defaultValue.avatar" :size="avatarWidth"></el-avatar>
            </div>
            <div :class="$style['leftRegion__top__right']">
              <div class="name">{{ defaultValue.name }}</div>
              <div class="title">{{ defaultValue.title }}</div>
              <div class="secondTitle"> {{ userGroupTitles }} </div>
            </div>
          </div>
          <!-- 2. 大頭貼底下聯絡資訊 -->
          <div :class="[$style['leftRegion__bottom'], { isEmployeeMob: type === 'employee' }]">
            <div>
              {{ defaultValue.phoneNumber }}
            </div>
            <div>
              {{ defaultValue.email }}
            </div>
            <div v-if="type !== 'employee'" :class="$style['leftRegion__bottom__contact_R']">
            <BaseIcon name="briefcase" :class="$style['leftRegion__bottom__icon']"></BaseIcon>{{
              `${defaultValue.takeOfficeDate || ''} -
                        ${defaultValue.leaveOfficeDate ? defaultValue.leaveOfficeDate + '(離職)' : '目前在職中'}`
            }}
          </div>
        </div>
      </div>
      <!-- 2. 右大區塊 -->
      <div v-if="openBasicInfo" :class="[$style.rightRegion, { isEmployeeMob: type === 'employee' }]">
        <div :class="$style['rightRegion__header']">
          <h4>基本資訊</h4>
            <el-button type="text" @click="onClickEdit">
              <BaseIcon name="edit" :class="$style['rightRegion__headerIcon']" class="text-primary align-text-top">
              </BaseIcon>
              <span class="hidden-mobile">編輯資訊</span><span class="visible-mobile"></span>
            </el-button>
          </div>
          <div :class="[$style['rightRegion__content'], { isEmployeeMob: type === 'employee' }]">
            <div>
              <span class="title">可服務地點</span><span class="content">{{ storeTitles }}</span>
            </div>
            <div>
              <span class="title">可同時服務人數</span><span class="content">{{ defaultValue.maxCollision || '無' }}</span>
            </div>
            <div v-if="!isSpace">
              <span class="title">證照</span><span class="content">{{ defaultValue.certificate || '無' }}</span>
            </div>
            <div v-if="!isSpace">
              <span class="title">專長</span><span class="content">{{ defaultValue.specialty || '無' }}</span>
            </div>
            <div>
              <span class="title">介紹</span><span class="content">{{ defaultValue.description || '無' }}</span>
            </div>
          </div>
        </div>
        <!-- 3. 展開區塊 -->
        <div v-if="fullWidth <= 768" :class="[$style.extendRegion, { isEmployeeMob: type === 'employee' }]"
          @click="openBasic">
          <BaseIcon icon-style="fal" name="chevron-down" :class="[{ degree180: openBasicInfo }]" />
          <p>{{ !openBasicInfo ? '展開' : '收合' }}</p>
        </div>
      </el-card>

      <div :class="[$style.center, { isEmployeeMob: type === 'employee' }]">
        <div :class="[$style['center__search'], { isEmployeeMob: type === 'employee' }]">
          <h4>最新預約記錄</h4>
          <div class="block full">
            <el-date-picker v-model="filterMonth" type="month" placeholder="不限月份" value-format="yyyy-MM"
              @change="tryToFetchList" class="bg-white is-border is-icon-pl-10">
            </el-date-picker>
          </div>
        </div>
        <div class="Jost" :class="$style.statistics">
          <div class="block">
            <div class="titleMargin">
              <BaseIcon name="cut" :icon-style="'fal'"></BaseIcon>
              <span>訂單筆數 </span>
            </div>

            <div class="block-more">
              <span :class="$style['prefix--type1']"> {{ defaultValue.ordersCount }} 筆訂單</span>
              <span :class="$style['prefix--type2']"> {{ defaultValue.helperOrderCount }} 筆訂單</span>
            </div>
          </div>
          <div class="block">
            <div class="titleMargin">
              <BaseIcon name="money-check-alt" :icon-style="'fal'"></BaseIcon>
              <span>訂單累計 </span>
            </div>
            <div class="block-more">
              <span :class="$style['prefix--type1']"> ${{ defaultValue.allActualPayTotal }}</span>
              <span :class="$style['prefix--type2']"> ${{ defaultValue.helperAllActualPayTotal }}</span>
              <!-- <span :class="$style['prefix--type3']">折扣金額 ${{ defaultValue.helperAllActualPayTotal }}</span> -->
            </div>
          </div>
          <div class="block">
            <div class="titleMargin">
              <BaseIcon name="file-invoice-dollar" :icon-style="'fal'"></BaseIcon>
              <span>接單累計 </span>
            </div>
            <div class="block-more">
              <span :class="$style['prefix--type1']"> ${{ defaultValue.allSalesTotal }}</span>
              <span :class="$style['prefix--type2']"> ${{ defaultValue.helperAllSalesTotal }}</span>
            </div>
          </div>
          <div class="block">
            <div class="titleMargin">
              <BaseIcon name="clock" :icon-style="'fal'"></BaseIcon>
              <span>當月排班 </span>
            </div>
            <div class="block-more">
              <span :class="$style['prefix--type4']"> {{ defaultValue.scheduleTotalHours.toFixed(1) }}小時</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 下方 table  -->
      <div class="el-table-wrapper" :class="$style.paddingSet">
        <el-table v-if="type !== 'employee'" v-loading.fullscreen.lock="tryingToGetOrder" element-loading-text="取得訂單資訊中"
          :data="loadedOrders" :default-sort="{ prop: 'created', order: 'descending' }"
          :row-class-name="tableRowClassName" style="padding:0 20px 40px" @cell-click="onCellClick">
          <el-table-column v-slot="{ row }" label="#訂單編號" width="220">
            <div class="Jost">{{ `#${row.id}` }}</div>
            <div class="Jost">{{ row.date | formatDate }} {{ row.time }}</div>
          </el-table-column>
          <el-table-column v-slot="{ row }" label="付款狀態" width="100">
            <BaseStateLabel :state="row.paymentStatus | paymentStatusMapFilter('color')" text>{{ row.paymentStatus |
              paymentStatusMapFilter('text')
            }}</BaseStateLabel>
          </el-table-column>
          <el-table-column v-slot="{ row }" label="預約狀態" width="100">
            <BaseStateLabel state="info" text>{{ row.status | bookingStatusFilter('text') }}</BaseStateLabel>
          </el-table-column>
          <el-table-column v-slot="{ row }" :label="`${$t('orderManage.USER_AND_PET')}`" width="190">
            <p :class="$style.pTextM">{{ row.fullName }} {{ row.gender | genderFilter }}</p>
            <p :class="$style.pTextS">{{ row.phoneCode }} {{ row.phoneNumber }}</p>
            <p :class="$style.pTextS">{{ row.pet.name }}</p>
          </el-table-column>
          <el-table-column v-slot="{ row }" label="訂購項目" width="220">
            <div>
              <p class="Jost" :class="$style.pTextM">{{ row.params[0].title }}</p>
              <p :class="$style.pTextS">{{ row.date | formatDate }} {{ row.time }}</p>
              <p :class="$style.pTextS">{{ row.productName }}</p>
            </div>
          </el-table-column>
          <el-table-column width="110">
            <template slot="header">
              訂單金額 <el-tooltip content="訂單金額以折扣後計算(包含預付扣款)" placement="right">
                <BaseIcon name="info-circle" />
              </el-tooltip>
            </template>
            <template slot-scope="scope"> ${{ scope.row.allActualPayTotal }} </template>
          </el-table-column>
          <el-table-column width="110">
            <template slot="header">
              接單金額 <el-tooltip content="接單金額以服務項目和加購項目的售價計算" placement="right">
                <BaseIcon name="info-circle" />
              </el-tooltip>
            </template>
            <template slot-scope="scope"> ${{ scope.row.allSalesTotal }} </template>
          </el-table-column>
        </el-table>
        <el-table v-else v-loading.fullscreen.lock="tryingToGetOrder" element-loading-text="取得訂單資訊中" :data="loadedOrders"
          :default-sort="{ prop: 'created', order: 'descending' }" :class="$style.elTableEmployee" :row-class-name="tableRowClassName"
          style="padding:0 0 40px" @cell-click="onCellClick">
          <el-table-column v-slot="{ row }" label="服務項目/服務時間" min-width="200">
            <div class="Jost">到店 {{ row.params[0].title }}</div>
            <div class="Jost" style="font-size:12px;">{{ row.date | formatDate }} {{ row.time }}</div>
            <div class="Jost" style="font-size:12px;">訂單/接單金額:NT${{ row.allActualPayTotal }}/NT${{ row.allPayTotal }}
            </div>
          </el-table-column>

          <el-table-column v-slot="{ row }" label="預約狀態" width="120">
            <div state="info" class="Jost" text>{{ row.status | bookingStatusFilter('text') }}</div>
            <div state="info" class="Jost" style="font-size:12px;" text>{{ $t('reserve.CLIENT')}}：{{ row.pet.name }}</div>
          </el-table-column>
        </el-table>
      </div>
      <BasePagination ref="pagination" :current-page.sync="currentPage" />
      <el-drawer ref="orderFormEdit" class="only-close"
        :class="{ 'appStyle': appStyle, 'isStyleOrderDetail': type === 'employee' }" :visible.sync="drawerVisible"
        append-to-body :size="$root.isSmallDevice ? '100%' : '90%'" destroy-on-close :wrapper-closable="false"
        custom-class="order-drawer" @closed="componentKey++">
        <ReservationOrderDetail v-if="type !== 'employee'" ref="orderDetail" :key="componentKey" order-type="reservation"
          :default-value.sync="drawerOrderData" @update="tryToFetchList" />
        <EmployeeReservationOrderDetail v-else ref="orderDetail" :key="componentKey" is-employee order-type="reservation"
          :default-value.sync="drawerOrderData" @update="tryToFetchList" @closeDrawer="drawerVisible = false" />
      </el-drawer>
    </template>
    <div>
      <!-- 編輯資訊點進來 -> 高級人員mode -->
      <ScheduleStaffForm v-if="visibleEdit && type !== 'employee'" :fetch-types="fetchTypes" :is-space="isSpace" :default-value="dialogItem" @store="tryToFetchList"
        @close="closeEdit" @goBack="closeEdit"/>
      <!-- 編輯資訊點進來 -> 美容師mode -->
      <ScheduleStaffForm v-if="visibleEdit && type === 'employee'"  :fetch-types="fetchTypes" :is-space="isSpace" access-type="employee" :default-value="dialogItem"
        @store="tryToFetchList" @close="closeEdit" @goBack="closeEdit" />
    </div>
  </div>
</template>
<style lang="scss" module>

.isStyleEmployee {
  @include touch {
    padding-bottom: 8rem;
  }
}

.header {
  background-color: $color-body-bg;
  padding: 20px 0;

  :global {
    .el-page-header {
      align-items: center;
      font-size: 22px;
    }

    .el-page-header__left {
      border: 1px solid $color-border-for-bg-white;
      border-radius: $border-radius;
      padding: 12px 24px;
      background-color: white;
    }
  }
}

.paddingSet {
  :global {
    .el-table_1_column_1>.cell {
      padding-left: 10px;
    }
  }
}

.leftRegion {
  background-color: white;
  display: flex;
  width: 266px;
  height: 250px;
  flex-direction: column;
  justify-content: center;
  padding: 26px 18px 30px;
  margin-right: 18px;

  &:global {
    &.isEmployeeMob {
      @include max-md {
        border-bottom: 1px solid $color-border-for-bg-white;
        padding: 26px 18px 20px;
      }
    }
  }

  @include pad {
    width: 100%;
  }

  &__top {
    display: flex;
    align-items: center;
    border-bottom: 1px solid $color-border-for-bg-white;
    padding-bottom: 18px;

    &_img {
      margin-right: 12px;
    }

    &__right {
      display: flex;
      flex-direction: column;
      align-items: start;
      justify-content: space-around;
      flex-grow: 1;
      height: 100%;

      :global {
        .name {
          color: $color-primary;
        }

        .title {
          color: $color-text-secondary;
        }

        .secondTitle {
          color: $color-text-light;
        }
      }
    }
  }

  &__bottom {
    display: flex;
    flex-direction: column;
    margin-top: 18px;

    &__icon {
      margin-right: 5px;
    }

    &__contact_R {
      margin-top: 12px;
    }

    &:global {
      &.isEmployeeMob {
        @include max-md {
          flex-direction: row;
          justify-content: space-between;

          div {}
        }
      }
    }
  }
}

.rightRegion {
  padding: 18px;
  background-color: white;
  flex-grow: 1;
  height: 250px;
  width: 635px;

  &:global {
    &.isEmployeeMob {
      height: auto;

      @include max-md {
        width: 100%;
        padding-bottom: 0;
      }
    }
  }

  &__header {
    display: flex;
    justify-content: space-between;

    :global {
      .el-button {
        // &:hover {
        //   background-color: white;
        //   color: black;
        // }
      }
    }

    @include max-sm {
      flex-direction: column;
      align-items: center;
    }

    @include pad {
      flex-direction: row;
    }
  }

  &__headerIcon {
    color: $color-primary;
    font-size: 20px;
  }

  &__content {
    flex-grow: 1;
    height: 160px;
    overflow: auto;

    &:global {
      &.isEmployeeMob {
        padding-top: 0;

        @include max-md {
          height: 300px;
        }
      }
    }

    :global {
      div {
        display: flex;
        line-height: 25px;
        letter-spacing: 1.4px;
        margin-bottom: 10px;

        @include max-sm {
          flex-direction: column;
        }

        @include max-md {
          flex-direction: column;
        }

        .title {
          flex-basis: 25%;
          color: $color-text-light;

          @include pad {
            flex-basis: 10%;
          }
        }

        .content {
          flex-basis: 75%;
          padding-left: 30px;
          color: $color-secondary;

          @include pad {
            flex-basis: 90%;
          }

          @include max-sm {
            padding-left: 0;
          }

          @include max-md {
            padding-left: 0;
          }
        }
      }
    }

  }
}

.extendRegion {
  display: flex;
  justify-content: center;
  align-items: center;
  // display: none;

  // @include max-md {
  //   display: flex;
  // }

  :global {
    p {
      text-align: center;
      margin-left: 10px;
    }

    svg {
      color: $color-primary;
    }

    .degree180 {
      transform: rotate(180deg);


    }
  }
}

.center {
  padding: 18px 20px;
  display: flex;
  flex-direction: column;
  background-color: white;

  &:global {
    &.isEmployeeMob {
      padding: 18px 0;

      @include max-sm {
        padding: 18px 0;
      }
    }
  }

  &__search {
    display: flex;
    justify-content: space-between;

    :global {
      .el-icon-date::before {
        padding-right: 10px
      }
    }

    &:global {
      &.isEmployeeMob {
        flex-direction: column;

        @include max-sm {
          padding: 18px 0;
        }
      }
    }
  }
}

.prefix {
  &--type1::before {
    content: '美容師:';
    color: $color-text-light;
  }

  &--type2::before {
    content: '助理:';
    color: $color-text-light;
  }

  &--type3::before {
    content: '折扣金額:';
    color: $color-text-light;
  }

  &--type4::before {
    content: '合計:';
    color: $color-text-light;
  }
}

.flex {
  display: flex;
  justify-content: space-between;
  align-items: center;

  @include pad {
    flex-wrap: wrap;
  }
}

.info {
  display: flex;
  justify-content: space-between;
  padding-bottom: 30px;

  &:global {
    border: 0;

    &.isEmployeeMob {
      margin-top: 40px;
      background-color: white;
      border: 1px solid $color-border-for-bg-white;
      padding-bottom: 0px;

      .el-avatar {
        @include pad {}
      }

      .el-card__body {
        padding: 0;

        @include pad {
          flex-direction: column;
        }
      }
    }
  }

  :global {


    .el-card__body {
      display: flex;
      width: 100%;
      padding: 0;

      @include pad {
        padding: 1rem;
      }
    }

    .half-upper {
      display: flex;

      @include max-sm {
        flex-direction: column;
        align-items: center;
      }

      .basic-info {
        padding-left: 45px;
        width: calc(100% - (var(--avatar-width) * 1px));

        @include pad {
          width: 100%;
          padding-left: 0;
        }

        .name {
          font-size: 20px;
          letter-spacing: 2px;
          line-height: 29px;
          font-weight: 500;
        }

        .title {
          margin-top: 10px;
          margin-right: 60px;
          color: $color-primary;
          letter-spacing: 2.8px;
          line-height: 20px;
        }

        button {
          padding: 12px 34px;

          @include pad {
            padding: 12px 20px;
          }
        }

        .contact {
          font-size: 14px;
          color: #726f65;
          padding-bottom: 25px;
          border-bottom: 2px solid #c6c6ba;
          margin-top: 42px;
          letter-spacing: 0.7px;
          margin-bottom: 34px;

          @include pad {
            margin-top: 30px;
            padding-bottom: 10px;

            div {
              margin-bottom: 15px;
            }
          }

          svg {
            color: #726f65;
            margin-right: 8px;
            font-size: 16px;
          }
        }
      }

      .avatar {
        margin-bottom: 1rem;
      }
    }
  }
}

.statistics {
  display: flex;
  align-items: center;
  width: 100%;
  margin: 20px 0;
  background: white;

  @include pad {
    flex-wrap: wrap;
    width: auto;
    margin-left: -3px;
    margin-right: -3px;
  }

  :global {
    .block {
      display: flex;
      flex-direction: column;
      align-items: start;
      flex-grow: 1;
      flex-basis: 0;
      padding: 7px 20px 0px;
      line-height: 46px;
      height: 127px;
      border: 1px solid $color-border-for-bg-white;
      border-radius: $border-radius;
      margin-right: 20px;


      &:last-child {
        margin-right: 0;
      }

      @include pad {
        overflow: auto;

        &.full {
          width: 100%;
          padding: 0;

          svg {
            position: absolute;
            left: 36%;
          }
        }

        width: calc(50% - 6px);
        margin-left: 3px;
        margin-right: 3px;
        flex-basis: auto;
        // flex-direction: row;
        border: $color-border-base 1px solid;
        border-radius: 10px;
        margin-bottom: 12px;
        padding: 1rem;
        line-height: 1.5;
      }

      .titleMargin {
        color: $color-secondary;
        display: flex;
        align-items: center;
      }

      @include max-sm {
        .titleMargin {
          margin-bottom: 12px;
        }
      }

      .el-date-editor--month {
        .el-input__prefix {
          font-size: 18px;
          color: $color-primary;
        }

        input {
          background: transparent;
          padding-left: 35px;
        }
      }

      svg {
        font-size: 18px;
        // margin-right: 10px;
        color: $color-secondary;
        // margin-top: 10px;

        @include pad {
          font-size: 16px;
          margin-top: 0;
          margin-right: 1rem;
        }
      }

      &+.block {

        // border-left: 1px solid #c6c6ba;
        @include pad {
          border: $color-border-base 1px solid;
        }
      }

      .el-input__inner {
        padding: 0 !important;
        text-align: center;
      }

      .el-input__prefix {
        display: none;
      }
    }
  }
}

.block-label {
  border-radius: 8px;
  color: white;
  background: #60a32f;
  padding: 4px 7px;
  font-size: 12px;
  margin-left: 10px;
  font-weight: 300;

  &.is-disabled {
    background: #e35d5d;
  }
}

.pTextS {
  color: $color-secondary;
  font-size: 12px;
  margin-top: 0;
  margin-bottom: 0;
}

.pTextM {
  color: $color-secondary;
  font-size: 14px;
  margin-top: 0;
  margin-bottom: 0;
}

.elTableEmployee {
  :global {
    thead tr>th {
      background-color: #E5E7EB;
    }
  }
}</style>
